import React from 'react';
import {
  Input,
  Icon,
  Button,
  Checkbox,
  Modal,
  Alert,
  AppLocaleProvider
} from 'sd-ui-components';
import { inject, observer } from 'mobx-react';
import './Verify.less';
import Notifications from '../../components/Notifications/Notifications';
const { FormattedMessage, injectIntl } = AppLocaleProvider;
@inject('ConfigStore')
@inject('AuthStore')
@observer
class VerifyForm extends React.Component {
  state = {
    helpModalVisible: false
  };
  updateLoginInfo = (key, value) => {
    this.props.AuthStore.loginInfo[key] = value;
  };
  onChangeUpdateEmail = event => {
    this.updateLoginInfo(event.target.name, event.target.value);
  };
  onChangeLoginInfoCheckbox = event => {
    this.updateLoginInfo(event.target.name, event.target.checked);
  };

  next = () => {
    this.props.AuthStore.next();
  };

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.next();
    }
  };

  toggleModal = () => {
    this.setState({
      helpModalVisible: !this.state.helpModalVisible
    });
  };
  render() {
    const { loginInfo } = this.props.AuthStore;
    return (
      <div>
        <Alert
          className="default-notifications"
          type="warning"
          message={
            <FormattedMessage
              id="App.Login.Notifications"
              defaultMessage="SmartDrive is transitioning users to an email-based authentication. If you have migrated, use email otherwise use username."
            />
          }
          description={<span />}
          showIcon={true}
        />
        <div>
          <h1>
            <FormattedMessage
              id="App.Login.DriverLogin"
              defaultMessage="Driver login"
            />
            {!this.props.ConfigStore.config.betaMode && (
              <Icon
                icon="question-circle-o"
                size={20}
                className="login-help-icon"
                onClick={this.toggleModal}
              />
            )}
          </h1>
          <Modal
            title={
              <h3>
                <FormattedMessage
                  id="App.Login.NeedHelp"
                  defaultMessage="Need help?"
                />
              </h3>
            }
            visible={this.state.helpModalVisible}
            footer={[
              <Button key="closeButton" onClick={this.toggleModal}>
                <FormattedMessage
                  id="App.Navigation.Close"
                  defaultMessage="Close"
                />
              </Button>
            ]}
            wrapClassName="login-help-modal"
            closable={false}
          >
            <p>
              <FormattedMessage
                id="App.Help.GlobalTechnicalSupport"
                defaultMessage="Global technical support"
              />
              <br />
              <a href="mailto:customer.service@smartdrive.net">
                customer.service@smartdrive.net
              </a>
            </p>
            <p>
              <FormattedMessage
                id="App.Help.GlobalPartsService"
                defaultMessage="Global Parts and Service"
              />
              <br />
              <a href="mailto:parts-service@smartdrive.net">
                parts-service@smartdrive.net
              </a>
            </p>
          </Modal>
        </div>
        <div>
          {this.props.ConfigStore.config.fleetLoginUrl && (
            <a href={this.props.ConfigStore.config.fleetLoginUrl}>
              <FormattedMessage
                id="App.Login.TakeMeToFleetLogin"
                defaultMessage="Not a driver? Log in here instead"
              />{' '}
              <Icon icon="arrow-right" className="login-arrow-icon" />{' '}
            </a>
          )}
        </div>
        <div>
          <Notifications />
        </div>
        <div>
          <Input
            aria-label="email"
            name="email"
            className="login-email-input"
            value={loginInfo.email}
            onChange={this.onChangeUpdateEmail}
            onKeyDown={this.handleKeyDown}
            placeholder={this.props.intl.formatMessage({
              id: 'App.Verify.LoginEmail',
              defaultMessage: 'Username or Email address'
            })}
          />
        </div>
        <div className="login-password-remember-me-row">
          <Checkbox
            name="rememberMe"
            checked={loginInfo.rememberMe}
            onClick={this.onChangeLoginInfoCheckbox}
          >
            <FormattedMessage
              id="App.Login.RememberMe"
              defaultMessage="Remember me on this device"
            />
          </Checkbox>
        </div>
        <div>
          <Button
            type="primary"
            size="large"
            className="next-button"
            onClick={this.next}
            loading={this.props.AuthStore.loading.login}
          >
            <FormattedMessage id="App.Verify.Next" defaultMessage="Next" />
          </Button>
        </div>
      </div>
    );
  }
}
export default injectIntl(VerifyForm);



// WEBPACK FOOTER //
// ./src/containers/Verify/VerifyForm.jsx